// utils/announcements.js // right now this requires going and updating the index as well

import { noticeText, noticeHtml } from './bannercopy.js';
// ---- Presets ----
export const ANNOUNCEMENTS = {
  maintenance: {
    enabled: true,
    key: 'maint-2025-10-26a',
    emoji: '🛠️',
    variant: 'warning',
    dismissible: true,
    html: 'Scheduled maintenance <strong>Oct 25, 10:00AM–4:00PM PT</strong>. Requests may be delayed.',
    start_at:   '2025-10-25T10:00:00-07:00',
    expires_at: '2025-10-25T16:00:00-07:00',
    html_after: 'Maintenance completed. Thanks for your patience.',
    variant_after: 'success'
  },

notice_news: {
    enabled: true,
    key: 'notice-news-2025-10-two-tone-vue',
    emoji: '📣',
    variant: 'light',
    dismissible: true,
    marquee: true,
    marquee_speed: 90,
    density: 0.8,
    duo: true,
    label: 'News:',
    // label_html: 'News: <strong>Hot</strong>', // optional
    label_color: '#8c0000ff',
    desc: noticeText,               // plain-text fallback
    desc_html: noticeHtml,          // ← optional HTML (links, <strong>, etc.)
    desc_color: '#0f4ea9'
  },

  notice_duo: {
    enabled: true,
    key: 'notice-2025-10-two-tone-vue',
    emoji: '📣',
    variant: 'light',
    dismissible: true,
    marquee: true,
    marquee_speed: 90,
    density: 0.8, // lower (e.g. 0.5 means shorter height for banner, 1 is taller)
    duo: true,
    label: 'Notice!',
    label_color: '#0f2740',

    desc: noticeText,
    desc_color: '#0f4ea9'
  },

  closed_beta: {
    enabled: true,
    key: 'beta-2025-10',
    emoji: '🔒',
    variant: 'beta',
    dismissible: false,
    html: 'PathTracer is currently in <strong>Closed Beta</strong>. '
  },
  launch: {
    enabled: true,
    key: 'launch-1-0-announcea',
    emoji: '🎉',
    variant: 'success',
    dismissible: true,
    html: '<strong>PathTracer v1.0</strong> is rolling out! <a href="/features" class="lnk">See what’s new</a>.'
  }
};

// Default/fallback (you can still use this), but prefer resolveAnnouncement(slug)
export const ACTIVE_ANNOUNCEMENT = null;
//export const ACTIVE_ANNOUNCEMENT = 'notice_duo';

function parseIsoMaybe(s) {
  if (!s) return null;
  const t = Date.parse(s);
  return Number.isNaN(t) ? null : new Date(t);
}

/**
 * Resolve a single preset by slug.
 * Options:
 *  - now: Date (default new Date())
 *  - allowAfterOnlyFor: string[] slugs that may show html_after (default ['maintenance'])
 */
export function resolveAnnouncement(
  slug,
  { now = new Date(), allowAfterOnlyFor = ['maintenance'] } = {}
) {
  const a = ANNOUNCEMENTS[slug];
  if (!a || !a.enabled) return null;

  const startAt   = parseIsoMaybe(a.start_at);
  const expiresAt = parseIsoMaybe(a.expires_at);

  // Before window -> hide
  if (startAt && now < startAt) return null;

  // After window -> optionally swap to post-event message
  if (expiresAt && now > expiresAt) {
    const mayAfter = allowAfterOnlyFor.includes(slug);
    if (mayAfter && a.html_after) {
      return {
        ...a,
        key: (a.key || 'default') + ':after',
        variant: a.variant_after || a.variant || 'info',
        html: a.html_after,
        duo: false
      };
    }
    return null;
  }

  // Within window (or no window defined)
  return { ...a };
}

// Backward-compatible helper
export function getActiveAnnouncement(now = new Date()) {
  return resolveAnnouncement(ACTIVE_ANNOUNCEMENT, { now });
}
